<template>
  <v-container fluid>
    <v-row dense class="asset-detail-top-row">
      <v-col :cols="resourceViewExpanded ? 12 : 6" class="pa-3 resourcePanelColumn">
        <AssetResources
          :style="resourceViewExpanded ? 'height:760px' : ''"
          :key="resourcesComponent"
          v-on:reloadAsset="ReloadAsset()"
        ></AssetResources>
      </v-col>

      <v-col :cols="resourceViewExpanded ? 12 : 6" class="pa-3">
        <v-card class="ma-0 pa-0" min-width="200px">
          <v-container>
            <v-col class="pt-0">
              <v-row>
                <v-card
                  color="primaryDark"
                  min-height="55px"
                  width="100%"
                  dark
                  class="pa-2 subtitle-1"
                >
                  <v-row dense>
                    <v-col align-self="center" class="pl-4 pa-0">
                      My Asset Details
                    </v-col>
                    <template v-for="(action, index) in actions">
                      <v-col
                        cols="auto"
                        class="pr-4 pl-4"
                        style="padding-bottom: 0px !important"
                        :key="index"
                        v-if="
                          (!action.editAction ||
                            (action.editAction && CanUserEditAssets)) &&
                          (action.onClick !== 'CloneAsset' ||
                            (hasClonableSection && hasAvailableTargetMarkets))
                        "
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              icon
                              v-on:click="HandleFunctionCall(action.onClick)"
                            >
                              <v-icon size="24" dark v-on="on">{{
                                action.icon
                              }}</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ action.description }}</span>
                        </v-tooltip>
                      </v-col>
                    </template>
                    <v-col
                      cols="auto"
                      class="pr-4 pl-4"
                      style="padding-bottom: 0px !important"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-if="isEditing || changesInContent"
                            size="24"
                            color="green"
                            dark
                            v-on="on"
                            >mdi-loading mdi-spin</v-icon
                          >
                          <v-icon v-else size="24" color="green" dark v-on="on"
                            >mdi-check-circle</v-icon
                          >
                        </template>
                        <span v-if="isEditing || changesInContent">Saving</span>
                        <span v-else>Saved</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-card>
              </v-row>
            </v-col>
            <v-col dense style="padding-top: 0px !important">
              <v-row class="cardContent pa-0" dense>
                <v-col cols="3" dense>Identifier:</v-col>
                <v-col dense>
                  <TextEditor
                    :value="this.asset.identifier"
                    v-on:onEdit="
                      (newIdentifier) => {
                        this.asset.identifier = newIdentifier;
                        this.OnAssetEdit();
                      }
                    "
                    v-bind:forcedEdit="myAssetTextFieldsForcedEdit"
                  >
                  </TextEditor>
                </v-col>
              </v-row>
              <v-row class="cardContent pa-0" dense>
                <v-col cols="3" dense>Name:</v-col>
                <v-col dense>
                  <TextEditor
                    :value="this.asset.name"
                    v-on:onEdit="
                      (newName) => {
                        this.asset.name = newName;
                        this.OnAssetEdit();
                      }
                    "
                    v-bind:forcedEdit="myAssetTextFieldsForcedEdit"
                  ></TextEditor>
                </v-col>
              </v-row>
              <v-row
                class="cardContent pa-0"
                dense
                v-if="asset.categoryName != null"
              >
                <v-col cols="3" dense>Category:</v-col>
                <v-col dense>
                  {{ asset.categoryName }}
                </v-col>
              </v-row>
              <v-row class="cardContent pa-0" dense>
                <v-col cols="3" dense>Description:</v-col>
                <v-col dense>
                  <TextEditor
                    :isTextArea="true"
                    :value="this.asset.description"
                    v-on:onEdit="
                      (newDescription) => {
                        this.asset.description = newDescription;
                        this.OnAssetEdit();
                      }
                    "
                    v-bind:forcedEdit="myAssetTextFieldsForcedEdit"
                  ></TextEditor>
                </v-col>
              </v-row>
              <v-row class="cardContent pa-0" dense>
                <v-col cols="3" dense>Created Date:</v-col>
                <v-col dense>
                 {{ formatDate(asset.creationDate) }}
                </v-col>
              </v-row>
              <v-row class="cardContent pa-0" dense>
                <v-col cols="3" dense>Created By:</v-col>
                <v-col dense>
                 {{ asset.createdBy }}
                </v-col>
              </v-row>
              <v-row class="cardContent pa-0" dense>
                <v-col cols="3" dense>Modified Date:</v-col>
                <v-col dense>
                 {{ formatDate(asset.modifiedDate) }}
                </v-col>
              </v-row>
              <v-row class="cardContent pa-0" dense>
                <v-col cols="3" dense>Modified By:</v-col>
                <v-col dense>
                 {{ asset.modifiedBy || '-' }}
                </v-col>
              </v-row>
            </v-col>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="mt-4">
      <v-col cols="12" class="pa-3">
        <v-card>
          <v-col class="pt-0 pb-0">
            <v-row>
              <v-card
                color="primaryDark"
                min-height="55px"
                width="100%"
                dark
                class="pa-2 subtitle-1"
              >
                <v-row no-gutters="">
                  <span>
                    Asset Content
                  </span>
                  <v-spacer></v-spacer>
                  <v-btn
                    v-if="clipboardText != null"
                    class="mr-4"
                    small
                    dense
                    height="28px"
                    :disabled="!CanUserEditAssets"
                    width="165px"
                    :color="'blue'"
                    @click="OnPasteContent"
                  >
                    Paste Content
                  </v-btn>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        class="ma-0"
                        small
                        dense
                        height="28px"
                        width="145px"
                        :disabled="!CanUserEditAssets"
                        :color="'green'"
                        v-on="on"
                      >
                        <span class="pa-2 pl-4">Add Content</span>
                        <v-icon left light>mdi-plus-circle-outline</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(item, index) in addContentDropdown"
                        :key="index"
                        @click="OnAddNewContent(item)"
                      >
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-row>
              </v-card>
            </v-row>
          </v-col>
          <v-row class="cardContent">
            <v-col
              cols="12"
              v-for="(content, index) in asset.contents"
              :key="index"
            >
              <v-card>
                <v-row no-gutters="" class="pa-2 pb-0">
                  <span class="overline">
                    {{ GetTextForContentType(content.type) }}
                  </span>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="OnCopyContent(index)">
                    <v-icon>
                      mdi-content-duplicate
                    </v-icon>
                  </v-btn>
                  <v-btn icon @click="OnRemoveContent(index)">
                    <v-icon>
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </v-row>
                <v-col cols="12" class="pt-0 mt-0">
                  <asset-detail-content
                    :content="content"
                    v-on:OnChangeContent="
                      (data) => {
                        OnChangeContent(data, index);
                      }
                    "
                  >
                  </asset-detail-content>
                </v-col>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" class="pa-3">
        <v-card>
          <v-col class="pt-0 pb-0">
            <v-row>
              <v-card
                color="primaryDark"
                min-height="55px"
                width="100%"
                dark
                class="pa-2 subtitle-1"
              >
                <v-row no-gutters="">
                  <span>
                    Attributes
                  </span>
                  <v-spacer></v-spacer>
                  <v-btn
                    class="ma-0"
                    small
                    dense
                    height="28px"
                    width="145px"
                    :disabled="!CanUserEditAssets"
                    :color="'green'"
                    @click="newAttributeDialog = true"
                  >
                    <span class="pa-2 pl-4">Add Attribute</span>
                    <v-icon left light>mdi-plus-circle-outline</v-icon>
                  </v-btn>
                </v-row>
              </v-card>
            </v-row>
          </v-col>
          <v-container fluid class="pt-4">
            <v-row class="cardContent">
              <v-col
                cols="6"
                class="pa-4"
                v-for="(attribute, index) in asset.attributes"
                :key="attribute.id"
              >
                <attribute-field
                  :forceLoader="attributeForceReload"
                  :readOnly="!CanUserEditAssets"
                  :showDelete="CanUserEditAssets"
                  allowNewItems
                  v-on:RemoveAttribute="OnRemoveAttribute"
                  v-on:OnChanged="OnAttributeChanged"
                  :attribute="attribute"
                  :assetid="asset.assetListingid"
                >
                  <!--:taxonomy="{taxo}" -->
                </attribute-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="newAttributeDialog" width="600">
      <v-card class="pa-4">
        <v-row>
          <!--
                    <v-col cols="6">
                        <v-card height="200px">
                            <v-card-title>
                                From Category
                            </v-card-title>
                            <v-card-text>
                                Create a new attribute group from another category.
                            </v-card-text>
                            <v-card-actions>
                                <category-search
                                v-on:CategorySelected = OnNewCategorySelected
                                >
                                </category-search>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                    -->
          <v-col cols="12">
            <v-card height="200px" flat>
              <v-card-title>
                From Attribute
              </v-card-title>
              <v-card-text>
                Select an existing attribute that has been used elsewhere.
              </v-card-text>
              <v-card-actions>
                <attribute-search
                  v-on:AttributeSelected="OnNewAttributeSelected"
                >
                </attribute-search>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <!-- Clone Asset Dialog -->
    <clone-asset-dialog
      :visible.sync="cloneAssetDialog"
      :assetId="asset.assetDetailid"
    />

    <!-- Delete Asset Confirmation Dialog -->
    <v-dialog v-model="showDeleteAssetDialog" width="500px" persistent>
      <v-card>
        <v-card-title class="pa-3 headline">Delete Asset</v-card-title>
        <v-card-text>
          <v-row class="subtitle-1">
            <span>Are you sure you want to delete this asset?</span>
          </v-row>
          <v-row>
            This action cannot be undone.
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            style="width:100px"
            color="green darken-1"
            dark
            @click="showDeleteAssetDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            style="width:150px"
            color="red darken-1"
            dark
            @click="ConfirmDeleteAsset"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row class="mt-0">
      <v-col cols="12" class="pa-3">
        <AssetProfileDataPanel
          :assetId="(asset && asset.assetDetailid) || assetDetailid"
          :readOnly="!CanUserEditAssets"
        ></AssetProfileDataPanel>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

import AssetResources from "../../views/assetDetail/AssetResources.vue";
import TextEditor from "../../shared/TextEditor";
import AttributeField from "../../attributes/AttributeField";
import AttributeSearch from "../../attributes/AttributeSearch";
import AssetDetailContent from "./AssetDetailContent.vue";
import CloneAssetDialog from "./CloneAssetDialog.vue";
import AssetProfileDataPanel from "./AssetProfileDataPanel.vue";
import { v4 as uuidv4 } from "uuid";

export default {
  name: "AssetDetailEditor",
  components: {
    AssetResources,
    TextEditor,
    AttributeField,
    AttributeSearch,
    AssetDetailContent,
    CloneAssetDialog,
    AssetProfileDataPanel,
  },
  props: {
    //Asset detail id
    assetDetailid: {
      default: "",
      type: String,
    },
  },
  computed: {
    ...mapState("assetxpstate", ["asset", "section"]),
    ...mapState("navstate", ["clipboardText"]),
    ...mapState("sessionState", ["resourceViewExpanded"]),
    ...mapGetters("authentication", [
      "CanUserEditAssets",
      "hasAvailableTargetMarkets",
    ]),
    ...mapGetters("assetxpstate", ["hasClonableSection"]),
    /** Inline fields only after pencil: must be allowed to edit AND isEditing toggled on. */
    myAssetTextFieldsForcedEdit() {
      return this.CanUserEditAssets && this.isEditing;
    },
  },
  mounted: function() {
    setInterval(() => {
      if (this.changesInContent) {
        var inputModel = { id: this.asset.assetDetailid, content: [] };

        for (let i = 0; i < this.asset.contents.length; i++) {
          if (this.asset.contents[i].exportedData != null)
            inputModel.content.push(this.asset.contents[i].exportedData);
        }

        this.UpdateADContent(inputModel);
        this.changesInContent = false;
      }
    }, 1000);
  },
  data: () => ({
    attributeForceReload: 0,
    newAttributeDialog: false,
    cloneAssetDialog: false,
    showDeleteAssetDialog: false,
    resourcesComponent: 0,
    isEditing: false,
    changesInContent: false,
    inputModelUpdate: {
      type: Object,
    },
    actions: [
      {
        description: "Switch to View Mode",
        icon: "mdi-eye",
        onClick: "SwitchView",
        editAction: false,
      },
      {
        description: "Edit Asset",
        icon: "mdi-pencil",
        onClick: "EditAsset",
        editAction: true,
      },
      {
        description: "Clone Asset",
        icon: "mdi-content-copy",
        onClick: "CloneAsset",
        editAction: false,
      },
      {
        description: "Delete Asset",
        icon: "mdi-delete",
        onClick: "DeleteAsset",
        editAction: true,
      },
    ],
    addContentDropdown: [
      { title: "Article", type: 0 },
      { title: "Data Table", type: 1 },
      { title: "Key Facts", type: 2 },
    ],
    search: null,
    downloadingPDF: false,
  }),
  methods: {
    ...mapActions("assetxpstate", [
      "RemoveAsset",
      "GetAsset",
      "UpdateAsset",
      "GetSectionById",
      "UpdateAssetAttributeMulti",
      "UpdateAssetAttribute",
      "UpdateAssetAttributeAsset",
      "AddAttributeToAsset",
      "RemoveAttributeFromAsset",
      "UpdateADContent",
      "DownloadPDF",
    ]),
    ...mapActions("navstate", ["GetSelectedSection", "SetClipboardText"]),

    OnTapDownloadPDF() {
      this.downloadingPDF = true;
      this.DownloadPDF(this.asset.assetListingid).then(() => {
        this.downloadingPDF = false;
      });
    },
    GetTextForContentType(type) {
      if (type == 0) {
        return "Article";
      } else if (type == 1) {
        return "Data Table";
      }
    },
    OnChangeContent(exportedData, index) {
      this.asset.contents[index].exportedData = exportedData;
      this.changesInContent = true;
    },
    OnRemoveContent(index) {
      this.asset.contents.splice(index, 1);
      this.changesInContent = true;
    },
    OnAddNewContent(contentOption) {
      this.asset.contents.push({ id: uuidv4(), type: contentOption.type });
      this.changesInContent = true;
    },
    OnRemoveAttribute(attribute) {
      attribute.assetListingid = this.asset.assetListingid;
      this.RemoveAttributeFromAsset(attribute);
    },
    OnNewCategorySelected(evt) {
      var sendObj = new Object();

      sendObj.name = evt.name;
      sendObj.catFilters = [];
      sendObj.catFilters.push(evt.id);
      sendObj.attributeType = 3;

      sendObj.assetListingid = this.asset.assetListingid;
      this.AddAttributeToAsset(sendObj).then(() => {
        this.newAttributeDialog = false;
      });
    },
    OnNewAttributeSelected(evt) {
      var evtObj = evt;

      if (evt === Object(evt)) {
        // do nothing
      } else {
        evtObj = { name: evt, attributeType: 3 };
      }

      evtObj.assetListingid = this.asset.assetListingid;
      this.AddAttributeToAsset(evtObj).then(() => {
        this.newAttributeDialog = false;
      });
    },
    OnAttributeChanged(evt) {
      if (evt.attribute.attributeType == 0) {
        // Multi
        var multiArray = new Array();

        for (let i = 0; i < evt.values.length; i++) {
          multiArray.push(evt.values[i]);
        }

        this.UpdateAssetAttributeMulti({
          id: evt.attribute.id,
          multiChoiceItems: multiArray,
          attributeType: evt.attribute.attributeType,
          assetListingid: this.asset.assetListingid,
        }).then(() => {});
      } else if (
        evt.attribute.attributeType == 1 ||
        evt.attribute.attributeType == 2
      ) {
        // STRING or NUMERIC
        this.UpdateAssetAttribute({
          id: evt.attribute.id,
          val: evt.values[0],
          attributeType: evt.attribute.attributeType,
          assetListingid: this.asset.assetListingid,
        }).then(() => {});
      } else if (evt.attribute.attributeType == 3) {
        this.UpdateAssetAttributeAsset({
          id: evt.attribute.id,
          items: evt.values,
          catFilters: evt.attribute.catFilters,
          sectionFilters: evt.attribute.sectionFilters,
          attributeType: evt.attribute.attributeType,
          assetListingid: this.asset.assetListingid,
        }).then(() => {
          this.attributeForceReload += 1;
        });
      }
    },
    HandleFunctionCall(functionName) {
      this[functionName]();
    },
    OnAssetEdit() {
      this.inputModelUpdate.name = this.asset.name;
      this.inputModelUpdate.identifier = this.asset.identifier;
      this.inputModelUpdate.description = this.asset.description;
      this.inputModelUpdate.adId = this.asset.assetDetailid;
      this.inputModelUpdate.alId = this.asset.assetListingid;
      this.UpdateAsset(this.inputModelUpdate);
    },
    EditAsset() {
      this.isEditing = !this.isEditing;
    },
    DeleteAsset() {
      this.showDeleteAssetDialog = true;
    },
    ConfirmDeleteAsset() {
      this.RemoveAsset(this.asset.assetDetailid).then(() => {
        this.showDeleteAssetDialog = false;
        this.$router.push({
          name: "Section",
          params: { sectionName: this.section.name },
        });
      });
    },
    SwitchView() {
      this.$emit("switchAssetDetailView");
    },
    CloneAsset() {
      this.cloneAssetDialog = true;
    },
    ReloadAsset() {
      this.$emit("ReloadAsset");
    },
    ForceResourcesRerender() {
      this.resourcesComponent += 1;
    },
    OnCopyContent(index) {
      let json = JSON.stringify(this.asset.contents[index]);
      this.SetClipboardText(json);
    },
    OnPasteContent() {
      var contentObj = JSON.parse(this.clipboardText);
      contentObj.id = "";
      this.asset.contents.push(contentObj);
      this.changesInContent = true;
    },
    formatDate(isoString) {
      if (!isoString) return '-';
      const date = new Date(isoString);
      if (isNaN(date.getTime())) return '-';
      const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      const dd = String(date.getDate()).padStart(2, '0');
      const mmm = months[date.getMonth()];
      const yyyy = date.getFullYear();
      const hh = String(date.getHours()).padStart(2, '0');
      const min = String(date.getMinutes()).padStart(2, '0');
      return `${dd}.${mmm}.${yyyy} ${hh}:${min}`;
    },
  },
  watch: {},
};
</script>

<style scoped>
.v-btn {
  width: 30px;
  height: 30px;
  margin: 0px;
  padding: 0px;
}
.cardContent {
  margin: 0px;
  padding: 5px;
}

.asset-detail-top-row {
  margin-left: -1px;
  margin-right: -1px;
}

.resourcePanelColumn {
  overflow: hidden;
  min-height: 0;
}
</style>
